import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { useActivityBuilderFontStyles } from 'approot/activity-builder/theme/activity-builder-theme.style';

export const MultipleChoicePrintList = styled.div`
  display: flex;
  flex-direction: column;

  label {
    min-height: ${rem(40)};
    margin-bottom: ${rem(spacing8)};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const MultipleChoicePrintListText = styled.div`
  ${() =>
    useActivityBuilderFontStyles({
      isSmall: true,
    })}
`;
